import { SEO } from '../components/ui/SEO';
import { Hero } from '../components/sections/Hero';
import { Skills } from '../components/sections/Skills';
import { ExperienceSection } from '../components/sections/ExperienceSection';
import { FeaturedProjects } from '../components/sections/FeaturedProjects';
import { AIEngineering } from '../components/sections/AIEngineering';
import { ProductsSection } from '../components/sections/ProductsSection';
import { CertificationsPreview } from '../components/sections/CertificationsPreview';
import { CTA } from '../components/sections/CTA';
import { profile } from '../data/profile';

export function Home() {
  return (
    <>
      <SEO title={profile.seo.title} description={profile.seo.description} />
      <Hero />
      <Skills />
      <ExperienceSection />
      <FeaturedProjects />
      <AIEngineering />
      {/* <ProductsSection />
      <CertificationsPreview /> */}
      <CTA />
    </>
  );
}
